//
//
//
//
//

import axios from 'axios'
export default {// capture="camera"
  props:['path'],
  name: 'sample',
  data() {
    return {
      file: '',
      src: ''
    };
  },
  methods: {
    chooseFile(){
      this.$refs.fileinput.click()
    },
    uploading(event) {
      this.file = event.target.files[0]
      var windowURL = window.URL || window.webkitURL
      this.file = event.target.files[0]
      this.src = windowURL.createObjectURL(event.target.files[0])
      this.submit(event)
    },
    submit(event) {
      let param = new window.FormData()
      param.append('file', this.file)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Token':this.$store.getters.token
        }
      }
      this.$loading('图片上传中...')
      let url = process.env.BASE_API + 'AppClient/AppFile/UploadFile?path='+this.path+'&userid='+this.$store.getters.userInfo.userid
      axios.post(url, param, config).then((response) => {
        event.target.value = ''
        this.$vux.loading.hide()
        if(response.data.result){
          this.$emit('notice-success',response.data.data)
        }else{
          this.$alert(response.data.msg,"错误")
        }
      }).catch((error) => {
        event.target.value = ''
        this.$vux.loading.hide()
        this.$alert('服务器连接失败,请稍后再试!',"错误")
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/uploadFile/index.vue